import Vue from 'vue';
import axiosRequest from './axiosRequest';

Vue.use(axiosRequest);

export default {};
